var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { FormSection, SectionTitle, FormGrid, BuildingAddress } from './styles';
import { FormGridItem } from '../../Views/CreateTicketPage/TicketForm/styles';
import SearchableSelect from '../Common/SearchableSelect/SearchableSelect';
export var BuildingInformationSection = function (_a) {
    var formData = _a.formData, buildings = _a.buildings, towers = _a.towers, apartments = _a.apartments, errors = _a.errors, onInputChange = _a.onInputChange, _b = _a.showRelation, showRelation = _b === void 0 ? true : _b;
    var relationField = {
        key: 'relation',
        label: 'Relación',
        placeholder: 'Selecciona relación',
        options: [
            { value: 'tenant', label: 'Inquilino' },
            { value: 'proprietary', label: 'Propietario' },
            { value: 'both', label: 'Ambos' },
        ],
        onChange: function (value) {
            return onInputChange('relation', value);
        },
        error: errors.relation,
        disabled: undefined,
        gridSize: 6,
        clearable: true,
    };
    var selectFields = __spreadArrays([
        {
            key: 'building_id',
            label: 'Edificio',
            placeholder: 'Selecciona un edificio',
            options: buildings.map(function (building) { return ({
                value: building.id,
                label: building.name,
            }); }),
            onChange: function (value) {
                var building = buildings.find(function (b) { return b.id === value; });
                onInputChange('building_id', value);
                onInputChange('building_code', (building === null || building === void 0 ? void 0 : building.code) || '');
            },
            clearable: true,
            error: errors.building_id,
            gridSize: 6,
        },
        {
            key: 'tower_id',
            label: 'Torre',
            placeholder: 'Ninguna',
            options: towers.map(function (tower) { return ({
                value: tower.id,
                label: tower.name,
            }); }),
            onChange: function (value) {
                var tower = towers.find(function (t) { return t.id === value; });
                onInputChange('tower_id', value);
                onInputChange('tower_code', (tower === null || tower === void 0 ? void 0 : tower.code) || '');
            },
            clearable: true,
            disabled: !formData.building_id,
            gridSize: 6,
        },
        {
            key: 'apartment_id',
            label: 'Apartamento',
            placeholder: 'Selecciona apartamento',
            options: apartments.map(function (apartment) { return ({
                value: apartment.id,
                label: apartment.number,
            }); }),
            onChange: function (value) {
                var _a;
                var apartment = apartments.find(function (a) { return a.id === value; });
                onInputChange('apartment_id', value);
                onInputChange('apartment_number', ((_a = apartment === null || apartment === void 0 ? void 0 : apartment.number) === null || _a === void 0 ? void 0 : _a.toString()) || '');
            },
            clearable: true,
            error: errors.apartment_id,
            disabled: !formData.tower_id,
            gridSize: 6,
        }
    ], (showRelation ? [relationField] : []));
    var buildingAddress = useMemo(function () {
        var _a;
        return (React.createElement(BuildingAddress, null, (_a = buildings.find(function (building) { return building.id === formData.building_id; })) === null || _a === void 0 ? void 0 : _a.address));
    }, [formData.building_id, buildings]);
    return (React.createElement(FormGridItem, null,
        React.createElement(FormSection, null,
            React.createElement(SectionTitle, null, "Informaci\u00F3n del edificio"),
            React.createElement(FormGrid, { container: true, spacing: 2 }, selectFields.map(function (field) { return (React.createElement(Grid, { item: true, xs: 12, md: 6, key: field.key },
                React.createElement(SearchableSelect, { clearable: field.clearable, value: formData[field.key], onChange: field.onChange, options: field.options, placeholder: field.placeholder, disabled: field.disabled, error: field.error, label: field.label }),
                field.key === 'building_id' && buildingAddress)); })))));
};
export default BuildingInformationSection;
